const overrideAtmAddToTrolleyMapper = require('./override-add-trolley-mapper.js');

module.exports = function (data) {
    let event;
    const { trolleyProducts, eventId, startCart, area, crossSellType, eventData } = data;
    if (trolleyProducts && eventId) {
        event = {
            event: 'BWSAUaddToCart',
            eventContext: {
                startCart,
                area,
                products: trolleyProducts.map((product) => {
                    return {
                        quantity: product.Quantity,
                        unitPrice: product.Price,
                        unitWasPrice: product.WasPrice,
                        unitListPrice: product.ListPrice,
                        unitSalePrice: product.SalePrice,
                        unitDisplay: product.Unit,
                        productInfo: product.ProductData,
                        isOnSpecial: product.IsSpecial ? 'true' : 'false'
                    };
                }),
                typeOfCrossSell: crossSellType,
                eventID: eventId
            }
        };
    } else {
        event = {
            event: 'BWSAUaddToCart',
            eventContext: {
                startCart,
                area,
                quantity: data.product.Quantity,
                unitPrice: data.product.Price,
                unitWasPrice: data.product.WasPrice,
                unitListPrice: data.product.ListPrice,
                unitSalePrice: data.product.SalePrice,
                unitDisplay: data.product.Unit,
                productInfo: data.product.ProductData,
                isOnSpecial: data.product.IsSpecial ? 'true' : 'false',
                promoteIQCampaignId: data.product.CampaignId ? data.product.CampaignId : null,
                typeOfCrossSell: crossSellType,
                eventID: data.headers('x-eventid')
            }
        };
        event.eventContext.productInfo.isSponsored = data.product.IsSponsored ? 'yes' : 'no';
    }

    if (eventData) {
        Object.assign(event.eventContext, {
            eventCampaignName: eventData.campaignName,
            eventPlace: eventData.place,
            eventPosition: eventData.position,
            eventType: eventData.type
        });
    }
    if (event && event.eventContext) {
        overrideAtmAddToTrolleyMapper(event.eventContext);
    }
    return event;
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/atmmapper/add-to-trolley-mapper.js
 **/